import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpError } from 'app/helpers/httpError';
import { HttpRequestHelper } from 'app/helpers/httpRequestHelper';
import { ExposedListFMEReportsRes } from 'app/interfaces/responses/Exposed/exposedListFMEReportsRes';
import { ExposedListMessageLogRes } from 'app/interfaces/responses/Exposed/exposedListMessageLogRes';
import { ExposedReadDocumentRes } from 'app/interfaces/responses/Exposed/exposedReadDocumentRes';
import { ExposedReadMainLoansRes } from 'app/interfaces/responses/Exposed/exposedReadMainLoansRes';
import { HttpStatus } from 'app/interfaces/support/status/httpStatus';
import { AlertsService } from 'app/services/system/alerts/alerts.service';
import { LoaderService } from 'app/services/system/loader/loader.service';
import { environment } from 'environments/environment';
import { Observable, Subject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class LoansService {
    private httpRequestHelper = new HttpRequestHelper();

    constructor(
        private http: HttpClient,
        private loaderService: LoaderService,
        private alertsService: AlertsService,
        private router: Router
    ) {}

    public readMainLoans(showError = true): Observable<ExposedReadMainLoansRes> {
        this.loaderService.changeActiveLoaders(1);
        this.loaderService.changeLoaderMessage('Sæki upplýsingar');

        let subject = new Subject<ExposedReadMainLoansRes>();
        this.http
            .get(environment.localApi + 'loans/mainLoans')
            .subscribe(
                (res: HttpStatus<ExposedReadMainLoansRes>) => {
                    subject.next(res.returnItem);
                },
                (error) => {
                    if (showError) {
                        HttpError(this.alertsService, this.router, error, '', '', '', '');
                    } else {
                        console.log(error);
                    }
                }
            )
            .add(() => {
                this.loaderService.changeActiveLoaders(-1);
            });
        return subject.asObservable();
    }

    public generateFMEReport(): Promise<string> {
        this.loaderService.changeActiveLoaders(1);
        this.loaderService.changeLoaderMessage('Stofna vinnslu');

        return new Promise((resolve, reject) => {
            this.http
                .post(environment.localApi + `loans/FMEReports`, null, this.httpRequestHelper.getRequestOptionsAuth())
                .subscribe({
                    next: (res: HttpStatus<string>) => {
                        this.alertsService.changeAlertShowIcon(true);
                        this.alertsService.changeAlertSuccessMessage('Vinnsla stofnuð');
                        this.alertsService.changeAlertSuccessShow(true);
                        resolve(res.returnItem);
                    },
                    error: (error) => {
                        HttpError(this.alertsService, this.router, error, '', '', '', '');
                        reject(error);
                    },
                })
                .add(() => {
                    this.loaderService.changeActiveLoaders(-1);
                });
        });
    }

    public getFMEReportDocument(id: number, documentId: number): Observable<ExposedReadDocumentRes> {
        this.loaderService.changeActiveLoaders(1);
        this.loaderService.changeLoaderMessage('Sæki skjal');

        const subject = new Subject<ExposedReadDocumentRes>();
        this.http
            .get(`${environment.localApi}loans/FMEReports/${id}/files/${documentId}`, this.httpRequestHelper.getRequestOptionsAuth())
            .subscribe({
                next: (res: HttpStatus<ExposedReadDocumentRes>) => {
                    subject.next(res.returnItem);
                },
                error: (error) => {
                    HttpError(this.alertsService, this.router, error, '', '', '', '');
                },
            })
            .add(() => {
                this.loaderService.changeActiveLoaders(-1);
            });
        return subject.asObservable();
    }

    public getFMEReportList(showLoader: boolean = true): Promise<ExposedListFMEReportsRes[]> {
        if (showLoader) {
            this.loaderService.changeActiveLoaders(1);
            this.loaderService.changeLoaderMessage('Sæki skjöl');
        }

        return new Promise((resolve, reject) => {
            this.http
                .get(environment.localApi + `loans/FMEReports`)
                .subscribe({
                    next: (res: HttpStatus<ExposedListFMEReportsRes[]>) => {
                        resolve(res.returnItem);
                    },
                    error: (error) => {
                        HttpError(this.alertsService, this.router, error, '', '', '', '');
                        reject(error);
                    },
                })
                .add(() => {
                    if (showLoader) {
                        this.loaderService.changeActiveLoaders(-1);
                    }
                });
        });
    }

    public getRunningFMEReportGenerationMessages(showLoader: boolean = true): Promise<ExposedListMessageLogRes[]> {
        if (showLoader) {
            this.loaderService.changeActiveLoaders(1);
            this.loaderService.changeLoaderMessage('Sæki vinnslur');
        }

        return new Promise((resolve, reject) => {
            this.http
                .get(environment.localApi + `loans/FMEReports/processing`)
                .subscribe({
                    next: (res: HttpStatus<ExposedListMessageLogRes[]>) => {
                        resolve(res.returnItem);
                    },
                    error: (error) => {
                        HttpError(this.alertsService, this.router, error, '', '', '', '');
                        reject(error);
                    },
                })
                .add(() => {
                    if (showLoader) {
                        this.loaderService.changeActiveLoaders(-1);
                    }
                });
        });
    }
}
